import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "menuall"
};
const _hoisted_2 = {
  class: "menu_box acea-row row-between-wrapper"
};
const _hoisted_3 = {
  class: "menu_right acea-row row-between-wrapper"
};
const _hoisted_4 = {
  class: "acea-row row-between-wrapper"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 0,
  class: "menu_item_line_hover"
};
const _hoisted_10 = {
  key: 1,
  class: "menu_item_hover"
};
const _hoisted_11 = {
  class: "menu_item_hover_list acea-row row-top"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  class: "menu_item"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  key: 0
};
const _hoisted_21 = {
  key: 1
};
const _hoisted_22 = {
  class: "menu_en_cn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "menu_logo",
    onClick: _cache[0] || (_cache[0] = $event => $options.menugo('/'))
  }, [_createVNode(_component_el_image, {
    src: "http://www.boyuyinuo.com/webcss/logo.png"
  })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "menu_item",
    onMouseenter: _cache[2] || (_cache[2] = $event => $options.menuMouseEnter(0)),
    onMouseleave: _cache[3] || (_cache[3] = $event => $options.menuMouseLeave())
  }, [_createElementVNode("div", {
    class: _normalizeClass(["menu_item_tile", [$props.xzmenu == 0 ? 'activeed' : 'sleeped']]),
    onClick: _cache[1] || (_cache[1] = $event => $options.menugo('/'))
  }, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_5, "HOME")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_6, "首页")) : _createCommentVNode("", true)], 2)], 32), _createElementVNode("div", {
    class: "menu_item",
    onMouseenter: _cache[5] || (_cache[5] = $event => $options.menuMouseEnter(1)),
    onMouseleave: _cache[6] || (_cache[6] = $event => $options.menuMouseLeave())
  }, [_createElementVNode("div", {
    class: _normalizeClass(["menu_item_tile", [$props.xzmenu == 1 ? 'activeed' : 'sleeped']]),
    onClick: _cache[4] || (_cache[4] = $event => $options.goprojectlist(0, 1))
  }, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "PRODUCT")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "产品中心")) : _createCommentVNode("", true)], 2), $data.xzmenuid == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9)) : _createCommentVNode("", true), $data.xzmenuid == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cate_list, (item_cateson, index_cateson) => {
    return _openBlock(), _createElementBlock("div", {
      class: "menu_item_hover_link",
      onClick: $event => $options.goprojectlist(item_cateson.id, 1)
    }, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item_cateson.cate_name_en), 1)) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item_cateson.cate_name), 1)) : _createCommentVNode("", true)], 8, _hoisted_12);
  }), 256))])])) : _createCommentVNode("", true)], 32), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    class: _normalizeClass(["menu_item_tile", [$props.xzmenu == 5 ? 'activeed' : 'sleeped']]),
    onClick: _cache[7] || (_cache[7] = $event => $options.goxwlist(2, 5))
  }, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "NEWS")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_17, "公司新闻")) : _createCommentVNode("", true)], 2)]), _createElementVNode("div", {
    class: "menu_item",
    onMouseenter: _cache[9] || (_cache[9] = $event => $options.menuMouseEnter(7)),
    onMouseleave: _cache[10] || (_cache[10] = $event => $options.menuMouseLeave())
  }, [_createElementVNode("div", {
    class: _normalizeClass(["menu_item_tile", [$props.xzmenu == 7 ? 'activeed' : 'sleeped']]),
    onClick: _cache[8] || (_cache[8] = $event => $options.goxinwen(1, 7))
  }, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_18, "ABOUT")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_19, "关于我们")) : _createCommentVNode("", true)], 2)], 32), _createElementVNode("div", {
    class: "menu_item",
    onMouseenter: _cache[12] || (_cache[12] = $event => $options.menuMouseEnter(8)),
    onMouseleave: _cache[13] || (_cache[13] = $event => $options.menuMouseLeave())
  }, [_createElementVNode("div", {
    class: _normalizeClass(["menu_item_tile", [$props.xzmenu == 8 ? 'activeed' : 'sleeped']]),
    onClick: _cache[11] || (_cache[11] = $event => $options.goxinwen(18, 8))
  }, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_20, "CONTACT")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_21, "联系我们")) : _createCommentVNode("", true)], 2)], 32)]), _createElementVNode("div", _hoisted_22, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    onClick: _cache[14] || (_cache[14] = $event => $options.selectlag(2, 0))
  }, "CHINESE")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", {
    key: 1,
    onClick: _cache[15] || (_cache[15] = $event => $options.selectlag(1, 0))
  }, "Englishs")) : _createCommentVNode("", true)])])])]);
}